const form = document.querySelector<HTMLFormElement>("form#create_customer");
if (form) {
    const toggles = form.querySelectorAll("div.toggle-fields > x-checkbox") as NodeListOf<HTMLInputElement>;
    toggles.forEach((toggle) => {
        const inputs = toggle
            .closest("div.toggle-fields")
            .querySelectorAll(":scope > *") as NodeListOf<HTMLInputElement>;
        toggle.addEventListener("change", () => {
            Array.from(inputs)
                .filter((x) => x !== toggle)
                .forEach((input) => {
                    input.disabled = !toggle.checked;
                });
        });
    });
}
